/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AdjustInfusionSpeedAliases {
  ADJUST_INFUSION_SPEED_CONTEXTUAL_BAR = 'adjust-infusion-speed-contextual-bar',
  ADJUST_INFUSION_SPEED_DATE_TIME_FIELD = 'adjust-infusion-speed-date-time-field',
  ADJUST_INFUSION_SPEED_DATE_TIME_INPUT = 'adjust-infusion-speed-date-time-input',
  ADJUST_INFUSION_SPEED_FORM = 'adjust-infusion-speed-form',
  ADJUST_INFUSION_SPEED_INFUSION_SPEED_FIELD = 'adjust-infusion-speed-infusion-speed-field',
  ADJUST_INFUSION_SPEED_INFUSION_SPEED_INPUT = 'adjust-infusion-speed-infusion-speed-input',
  ADJUST_INFUSION_SPEED_JUSTIFICATION_FIELD = 'adjust-infusion-speed-justification-field',
  ADJUST_INFUSION_SPEED_JUSTIFICATION_TEXT_AREA = 'adjust-infusion-speed-justification-text-area',
  ADJUST_INFUSION_SPEED_LAYOUT = 'adjust-infusion-speed-layout',
  ADJUST_INFUSION_SPEED_PANEL = 'adjust-infusion-speed-panel',
  ADJUST_INFUSION_SPEED_REASON_AUTOCOMPLETE = 'adjust-infusion-speed-reason-autocomplete',
  ADJUST_INFUSION_SPEED_REASON_FETCH = 'adjust-infusion-speed-reason-fetch',
  ADJUST_INFUSION_SPEED_REASON_FIELD = 'adjust-infusion-speed-reason-field',
  ADJUST_INFUSION_SPEED_REASON_MAPPER = 'adjust-infusion-speed-reason-mapper',
  ADJUST_INFUSION_SPEED_REASON_TEXT = 'adjust-infusion-speed-reason-text',
  ADJUST_INFUSION_SPEED_UNIT_MEASURES_AUTOCOMPLETE = 'adjust-infusion-speed-unit-measures-autocomplete',
  ADJUST_INFUSION_SPEED_UNIT_MEASURES_FETCH = 'adjust-infusion-speed-unit-measures-fetch',
  ADJUST_INFUSION_SPEED_UNIT_MEASURES_FIELD = 'adjust-infusion-speed-unit-measures-field',
  ADJUST_INFUSION_SPEED_UNIT_MEASURES_MAPPER = 'adjust-infusion-speed-unit-measures-mapper',
  ADJUST_INFUSION_SPEED_UNIT_MEASURES_TEXT = 'adjust-infusion-speed-unit-measures-text',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  INFUSION_HEADER_FRAGMENT = 'infusion-header-fragment',
}
export { AdjustInfusionSpeedAliases };
